var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vdatetime" },
    [
      _c(
        "input",
        _vm._g(
          _vm._b(
            {
              staticClass: "vdatetime-input",
              class: _vm.inputClass,
              attrs: { type: "text" },
              domProps: { value: _vm.inputValue },
              on: { click: _vm.open, focus: _vm.open }
            },
            "input",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c(
        "transition-group",
        { attrs: { name: "vdatetime-fade", tag: "div" } },
        [
          _vm.isOpen
            ? _c(
                "div",
                {
                  key: "overlay",
                  staticClass: "vdatetime-overlay",
                  on: { click: _vm.cancel }
                },
                [
                  _c(
                    "div",
                    { key: "center", staticClass: "vdatetime-overlay-center" },
                    [
                      _vm.isOpen
                        ? _c("datetime-popup", {
                            key: "popup",
                            attrs: {
                              type: _vm.type,
                              datetime: _vm.popupDate,
                              phrases: _vm.phrases,
                              "use12-hour": _vm.use12Hour,
                              "hour-step": _vm.hourStep,
                              "minute-step": _vm.minuteStep,
                              "min-datetime": _vm.popupMinDatetime,
                              "max-datetime": _vm.popupMaxDatetime,
                              auto: _vm.auto,
                              "week-start": _vm.weekStart
                            },
                            on: { confirm: _vm.confirm, cancel: _vm.cancel }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60ef3de1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60ef3de1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/vue-datetime/Datetime.vue
// module id = null
// module chunks = 